import script from "./ProtectedImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProtectedImage.vue?vue&type=script&setup=true&lang=ts"

import "./ProtectedImage.vue?vue&type=style&index=0&id=7bac5cfb&lang=css"

const __exports__ = script;

export default __exports__